var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_995_330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.101 23.6919V15.7119H6.627V12.0449H9.101V10.4649C9.101 6.37992 10.949 4.48692 14.959 4.48692C15.36 4.48692 15.914 4.52892 16.427 4.58992C16.8112 4.62946 17.1924 4.69461 17.568 4.78492V8.10992C17.3509 8.08967 17.133 8.07766 16.915 8.07392C16.6707 8.06758 16.4264 8.06458 16.182 8.06492C15.475 8.06492 14.923 8.16092 14.507 8.37392C14.2273 8.51423 13.9922 8.7296 13.828 8.99592C13.57 9.41592 13.454 9.99092 13.454 10.7479V12.0449H17.373L16.987 14.1479L16.7 15.7119H13.454V23.9569C19.396 23.2389 24 18.1799 24 12.0449C24 5.41792 18.627 0.0449219 12 0.0449219C5.373 0.0449219 0 5.41792 0 12.0449C0 17.6729 3.874 22.3949 9.101 23.6919Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_995_330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.8ec216881b7f071ee75e1d77281364e2.svg";
export { ForwardRef as ReactComponent };